import { render, staticRenderFns } from "./SceneLg.vue?vue&type=template&id=43c33d96&scoped=true&"
import script from "./SceneLg.vue?vue&type=script&lang=js&"
export * from "./SceneLg.vue?vue&type=script&lang=js&"
import style0 from "./SceneLg.vue?vue&type=style&index=0&id=43c33d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c33d96",
  null
  
)

export default component.exports